import { Component, inject } from '@angular/core';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { InputType } from 'enums/InputType';
import { DashboardElementModel } from 'models/generated/Identity.Api.Models.DashboardElement';
import { UserDashboardElementSettingModel, UserSettingsModel, UserModel } from 'models/generated/Identity.Api.Models.User';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { DashboardService } from 'services/dashboard.service';
import { UserService } from 'services/user.service';
import { NavigationService } from 'services/navigation.service';
import { SortableDirective } from 'directives/sortable.directive';
import { RelationService } from 'services/relation.service';
import { CardComponent } from 'components/layout/card/card.component';

@Component({
	selector: 'user-settings',
	templateUrl: './user-settings.component.html',
	imports: [Layout, CustomInputComponent, TranslatePipe, SortableDirective, CardComponent]
})
export class UserSettingsComponent {

	private readonly userService = inject(UserService);
	private readonly dashboardService = inject(DashboardService);
	private readonly navigationService = inject(NavigationService);

	loading = false;
	inputType = InputType;
	user: UserModel;
	dashboardElements: DashboardElementModel[] = [];
	sortedDashboardElementIds?: string[];
	
	constructor() {
		this.loading = true;
		this.user = this.userService.getCurrentUser();
		this.loadSettings();
	}

	async loadSettings() {
		await this.loadDashboardSettings();
		this.loading = false;
	}

	async loadDashboardSettings() {
		this.dashboardElements = RelationService.deepClone(await this.dashboardService.getDashboardElements()).filter(elements => elements.teamDashboardElements.some(teamElement => this.user.userTeams.map(ut => ut.teamId).includes(teamElement.teamId)));
		let maxSortOrder = this.user.settings?.dashboardElementSettings.reduce((max, s) => Math.max(max, s.sortOrder ?? 0), 0) ?? 0;
		for (var element of this.dashboardElements) {
			element.settings = this.user.settings?.dashboardElementSettings.find(s => s.dashboardElementId == element.id) ?? new UserDashboardElementSettingModel();
			element.settings.dashboardElementId = element.id;
			element.settings.sortOrder = element.settings.sortOrder ?? ++maxSortOrder;
		}
		this.dashboardElements.sort((a, b) => (a.settings!.sortOrder ?? 0) - (b.settings!.sortOrder ?? 0));
	}

	updateElementsSortOrder(elements: DashboardElementModel[]) {
		this.sortedDashboardElementIds = elements.map(element => element.id!);
	}

	async save() {
		const settings = new UserSettingsModel();
		if (this.sortedDashboardElementIds) {
			for (let i = 0; i < this.sortedDashboardElementIds.length; i++) {
				const elementId = this.sortedDashboardElementIds[i];
				const element = this.dashboardElements.find(e => e.id == elementId);
				if (element && element.settings) {
					element.settings.sortOrder = i + 1;
				}
			}
		}
		settings.dashboardElementSettings = this.dashboardElements.map(element => element.settings!);

		await this.userService.updateSettings(this.user.id!, settings);
		this.navigationService.closeView(this);
	}
}

